import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

Amplify.configure({ 
  Auth: { 
    Cognito: { 
      userPoolId: environment.cognito.userPoolId, 
      userPoolClientId: environment.cognito.userPoolClientId, 
      loginWith: {
        oauth: {
          domain: environment.cognito.socialLogin.domain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: environment.cognito.socialLogin.redirectSignIn,
          redirectSignOut: environment.cognito.socialLogin.redirectSignOut,
          responseType: 'code'
        }
      }
    } 
  } 
}); 

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
